/**
 * Regras de validação final antes do envio na TransferForm.
 * Mantém a ordem das validações e facilita testes unitários.
 */

/**
 * Retorna um código de erro de validação da TransferForm
 * ou null quando está tudo ok para prosseguir com o envio.
 *
 * Códigos possíveis:
 * - 'invalid_recipient'
 * - 'invalid_amount'
 * - 'no_tokens'
 * - 'insufficient_balance'
 */
export function getTransferFormValidationError({
  hasValidRecipient,
  hasValidAmount,
  hasTokens,
  selectedTokenData,
  hasSufficientBalance,
}) {
  if (!hasValidRecipient) return 'invalid_recipient';
  if (!hasValidAmount) return 'invalid_amount';
  if (!hasTokens || !selectedTokenData) return 'no_tokens';
  if (!hasSufficientBalance) return 'insufficient_balance';
  return null;
}

